const OKTA_CONFIG_KEY = 'okta_config';

export const clearOktaConfig = () => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(OKTA_CONFIG_KEY);
  } catch (error) {
    console.warn('Failed to clear Okta config:', error);
  }
};

export const saveOktaConfig = (config) => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const oktaConfig = {
      issuer: config.issuer,
      clientId: config.clientId,
      redirectUri:
        config.redirectUri || `${window.location.origin}/login/callback`,
      scopes: config.scopes || ['openid', 'profile', 'email'],
      timestamp: Date.now(),
    };

    localStorage.setItem(OKTA_CONFIG_KEY, JSON.stringify(oktaConfig));
  } catch (error) {
    console.warn('Failed to save Okta config:', error);
  }
};

export const getOktaConfig = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const configStr = localStorage.getItem(OKTA_CONFIG_KEY);
    if (!configStr) {
      return null;
    }

    const config = JSON.parse(configStr);

    if (!config.issuer || !config.clientId) {
      console.warn('Invalid Okta config found, removing');
      clearOktaConfig();
      return null;
    }

    return config;
  } catch (error) {
    console.warn('Failed to get Okta config:', error);
    clearOktaConfig();
    return null;
  }
};

export const hasOktaConfig = () => {
  return getOktaConfig() !== null;
};
